'use client';

import { AccordionProvider } from './contexts/accordion-context';

export const SimpleAccordion = ({ 
	defaultValue,
	children 
}: {
	defaultValue?: string;
	children: React.ReactNode;
}) => {
	return (
		<AccordionProvider defaultValue={defaultValue}>
			{children}
		</AccordionProvider>
	);
};